import React from 'react';

const TrafficLight = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Traffic Light Base */}
            <rect x="6" y="1" width="8" height="18" rx="2" fill="#444444" />

            {/* Lights */}
            <circle cx="10" cy="5" r="2.2" fill="#555555" />
            <circle cx="10" cy="10" r="2.2" fill="#555555" />
            <circle cx="10" cy="15" r="2.5" fill="#32CD32" stroke="#228B22" stroke-width="0.3" />

            {/* Light Reflection */}
            <circle cx="9" cy="14.2" r="0.8" fill="#ffffff" fillOpacity="0.4" />
        </svg>
    );
};

export default TrafficLight;